import { adminCustomersRoutes } from "./Customers/customers-routes";
import AdminLayout from "./AdminLayout";
import { adminMembersRoutes } from "./Members/members-routes";
import OrgForm from "./Orgs/OrgForm";
import Invoices from "./Invoices/pages/Invoices";
import WhatsappConnect from "./Whatsapp/WhatsappConnect";
import { adminStatsRoutes } from "./Stats/stats-router";
import Profile from "./Profile/Profile";
import { adminTourPackagesRoutes } from "./TourPackages/tour-packages-routes";
import { adminBookingRoutes } from "./Bookings/bookings-routes";
import { adminFAQRoutes } from "./FAQ/faq-routes";
import { adminGroupTripsRoutes } from "./GroupTrip/group-trips-routes";
import { adminLocationsRoutes } from "./Locations/locations-routes";
import { adminReviewsRoutes } from "./Reviews/reviews-routes";
import { adminBroadcastRoutes } from "./Broadcast/broadcast-routes";
import { adminLeadsRoutes } from "./Leads/leads-routes";
import { adminContactsRoutes } from "./Contacts/contacts-routes";
import { adminProductsRoutes } from "./Products/products-routes";
import { adminSubOrdersRoutes } from "./SubOrders/sub-orders-routes";
import { adminRolesRoutes } from "./Roles/role-routes";
import { adminAIAgentsRoutes } from "./AIAgents/ai-agents.routes";
import { adminIntegrationsRoutes } from "./Integrations/integrations-routes";
import { adminAutomationsRoutes } from "./Automations/automations-routes";
import { adminChatsRoutes } from "./Chats/chats-routes";
import { adminPlansRoutes } from "./Plans/plans-routes";
import { adminTasksRoutes } from "./Tasks/tasks-routes";
import { adminTicketsRoutes } from "./Tickets/tickets-routes";
import { adminBranchesRoutes } from "./Branches/branches-routes";
import { adminTrainsRoutes } from "./Trains/trains-routes";
import { adminBaggagesRoutes } from "./Baggages/baggages-routes";
import { adminInboxRoutes } from "./Inbox/inbox-routes";
import { adminChannelsRoutes } from "./Channels/channels-routes";
import InstagramConnectPage from "./Channels/InstagramConnectPage";
import InstagramOAuth from "./AIAgents/InstagramOAuth";
import AutomationCreateKeyword from "./Automations/AutomationCreateKeyword";

export const adminRoutes = [
  {
    path: "admin",
    element: AdminLayout,
    name: "",
    children: [
      // /admin → главная страница (Аналитика)
      {
        path: "",
        redirect: "stats",
      },
      ...adminCustomersRoutes,
      {
        element: OrgForm,
        path: "orgs/:id/edit",
      },
      {
        element: Invoices,
        path: "invoices",
      },
      {
        element: WhatsappConnect,
        path: "whatsapp/connect",
      },
      {
        element: Profile,
        path: "profile",
      },
      ...adminMembersRoutes,
      ...adminTourPackagesRoutes,
      ...adminStatsRoutes,
      ...adminBookingRoutes,
      ...adminFAQRoutes,
      ...adminGroupTripsRoutes,
      ...adminLocationsRoutes,
      ...adminReviewsRoutes,
      ...adminBroadcastRoutes,
      ...adminLeadsRoutes,
      ...adminContactsRoutes,
      ...adminProductsRoutes,
      ...adminSubOrdersRoutes,
      ...adminRolesRoutes,
      ...adminAIAgentsRoutes,
      ...adminIntegrationsRoutes,
      ...adminAutomationsRoutes,
      ...adminChatsRoutes,
      ...adminPlansRoutes,
      ...adminTasksRoutes,
      ...adminTicketsRoutes,
      ...adminBranchesRoutes,
      ...adminTrainsRoutes,
      ...adminBaggagesRoutes,
      ...adminInboxRoutes,
      ...adminChannelsRoutes,
    ],
  },
  // Полноэкранные страницы — без меню и шапки админки
  {
    path: "admin/connect/instagram",
    element: InstagramConnectPage,
  },
  // Чат-бот на кодовое слово: создание и редактирование
  {
    path: "admin/automations/create/keyword",
    element: AutomationCreateKeyword,
  },
  {
    path: "admin/automations/create/keyword/:automationID",
    element: AutomationCreateKeyword,
  },
  // Возврат после входа через Instagram. Путь зарегистрирован в Meta как адрес возврата — не менять
  {
    path: "admin/ai-agents/instagram/oauth/callback",
    element: InstagramOAuth,
  },
];
